import * as React from 'react';

import styled, { css } from 'styled-components';

import { motion } from 'framer-motion';

import Typography from '@components/basics/typography';

interface HelperProps {
  className?: string;
  children: React.ReactNode;
  textLeft?: boolean;
  onTop?: boolean;
  isHover: boolean;
  noArrow?: boolean;
  moveRight?: boolean;
}

export const Helper: React.FC<HelperProps> = (props) => {
  const opacityHover = {
    hover: {
      opacity: 1,
    },
    rest: {
      opacity: 0,
    },
  };

  return (
    <motion.div
      className={`${props.className} ${props.isHover ? 'hover' : ''} ${
        props.noArrow ? 'no-arrow' : ''
      }`}
      initial="rest"
      exit="rest"
      variants={opacityHover}
      animate={props.isHover ? 'hover' : 'rest'}
    >
      <div className="helper-wrapper">
        <Typography className="text">{props.children}</Typography>
      </div>
    </motion.div>
  );
};

export default styled(Helper)`
  width: 100%;
  min-width: 260px;
  user-select: none;
  position: absolute;
  pointer-events: none;
  display: none;
  z-index: ${({ theme }) => theme.zIndices.underHeader};
  border-radius: ${({ theme }) => theme.general.borderRadius};
  filter: drop-shadow(
    ${({ theme }) => `${theme.general.boxShadowMenu} ${theme.colors.shadow}`}
  );

  &.hover {
    pointer-events: all;
    display: block;
  }

  ${(props) =>
    props.onTop
      ? css`
          bottom: calc(100% + 4px);
          left: -30px;
        `
      : css`
          top: calc(100% + 4px);
          right: 0;
        `}

  ${(props) =>
    props.textLeft
      ? css`
          left: 0;
          right: 0;
          top: calc(100% + 12px);
          @media ${({ theme }) => theme.device.tablet} {
            right: -20px;
            left: auto;
          }
        `
      : null}

  ${(props) =>
    props.onTop && props.textLeft
      ? css`
          top: auto;
          right: -20px;
          bottom: calc(100% + 4px);
          left: auto;
        `
      : null}

  ${(props) =>
    props.moveRight
      ? css`
          left: 0;
          right: 0;
          @media ${({ theme }) => theme.device.tablet} {
            right: auto;
            left: -20px;
          }
        `
      : null}

  &:before {
    content: '';
    height: 12px;
    width: 12px;
    background-color: ${({ theme }) => theme.colors.menuBackground};
    position: absolute;
    transform: rotate(45deg);
    border-radius: 4px;
    z-index: 0;
    @media ${({ theme }) => theme.device.tablet} {
      height: 16px;
      width: 16px;
    }

    ${(props) =>
      props.onTop
        ? css`
            top: calc(100% - 12px);
            left: 25px;
          `
        : css`
            bottom: calc(100% - 12px);
            left: 50%;
            transform: rotate(45deg) translate(-50%, 0);
            @media ${({ theme }) => theme.device.tablet} {
              right: 25px;
              left: auto;
              transform: rotate(45deg);
            }
          `}

    ${(props) =>
      props.onTop && props.textLeft
        ? css`
            right: 25px;
            left: auto;
          `
        : null}
        
    ${(props) =>
      props.moveRight
        ? css`
            @media ${({ theme }) => theme.device.tablet} {
              right: auto;
              left: 25px;
            }
          `
        : null}
  }

  &.no-arrow {
    &:before {
      content: none;
    }
  }

  .helper-wrapper {
    padding: 20px;
    position: relative;
    box-sizing: border-box;
    z-index: ${({ theme }) => theme.zIndices.underHeader};
    text-align: ${(props) => (props.textLeft ? 'left' : 'center')};
    background-color: ${({ theme }) => theme.colors.differentBackground};
    border-radius: ${({ theme }) => theme.general.borderRadius};

    .text {
      line-height: 20px;
    }
  }
`;
